import { margin } from '@10d/tend-ui-styling';
import styled from 'styled-components';

const Root = styled.header `
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: ${props => (props.$sticky ? 'sticky' : 'static')};
  z-index: 999;
  top: ${props => props.$top};

  padding: 8px 16px;
  background-color: ${props => props.$background};

  ${margin};
`;

export { Root };
